import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import InitialPageLoader from "../../../components/InitialPageLoader/InitialPageLoader";
// import Navbar from "../../components/Navbar/Navbar";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import LockIcon from "@mui/icons-material/Lock";

import styles from "./DashHome.module.css";
import UserProfile from "../../../components/UserProfile/UserProfile";
import OverviewDashboard from "../../../components/dashbaord/OverviewDashboard/OverviewDashboard";
import { useAuth } from "../../../contexts/AuthContext";
import axios from "axios";
import ProMoreQueries from "../../../components/dashbaord/ProMoreQueries/ProMoreQueries";
import DashProListings from "../../../components/dashbaord/DashProListings/DashProListings";
import SocialMediaManager from "../../../components/dashbaord/SocialMediaManager/SocialMediaManager";
import DashLandlordListings from "../../../components/dashbaord/DashLandlordListings/DashLandlordListings";
import DashProLicenses from "../../../components/dashbaord/DashProLicenses/DashProLicenses";
import DashFavoriteListings from "../../../components/dashbaord/dashboardUtil/DashFavoriteListings/DashFavoriteListings";
import DashProBlogs from "../../../components/dashbaord/DashProBlogs/DashProBlogs";
import DashProAgencies from "../../../components/dashbaord/DashProAgencies/DashProAgencies";
import ManageProfile from "../../../components/dashbaord/ManageProfile/ManageProfile";
import ProAiChatBot from "../../../components/RealtorAI/ProAIChatBot";
import DashChat from "../../../components/dashbaord/DashChat/DashChat";
import Scheduling from "../../Scheduling/Scheduling";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

// alert(import.meta.env.VITE_TEST);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function DashHome() {
  const { accessToken, userDetails } = useAuth();
  const location = useLocation();
  const [isTokenReady, setIsTokenReady] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [initialLoading, setInitialLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // New state for error messages
  const [userRoles, setUserRoles] = useState({});
  // Track if welcome messages have been displayed
  const [welcomeShown, setWelcomeShown] = useState(false);

  const isNewRealtor = searchParams.get("newRealtor");
  const isNewLandlord = searchParams.get("newLandlord");
  const isNewUser = searchParams.get("newUser");
  const isNewAgency = searchParams.get("newAgency");
  const category = searchParams.get("category");
  const isAgencyOnboard = searchParams.get("isAgencyOnboard");
  const chatIdFromParams = searchParams.get("chatId");
  const targetUserIdFromParams = searchParams.get("targetUserId");

  const [sectionMap, setSectionMap] = useState([
    { label: "Profile", url: "profile" },
  ]);

  const [value, setValue] = useState(0); // Tab index

  const locationProps = location.state || {};
  // console.log("locationProps: ", locationProps);

  const handleChange = (event, newValue) => {
    const selectedSection = sectionMap[newValue];

    // Prevent clicking on Pro AI tab
    if (selectedSection.url === "proai") {
      return;
    }

    setValue(newValue);
    updateCategoryParam(selectedSection.url);
  };

  const updateCategoryParam = (selectedCategory) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("category", selectedCategory);
    setSearchParams(newSearchParams);
  };

  const showSuccessMessage = (text) => {
    toast.success(text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const showErrorMessage = (text) => {
    toast.error(text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const fetchUserRoles = async (accessToken) => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_BACKEND_URL}/dash/roles`,
        {
          headers: {
            Authorization: accessToken,
          },
        }
      );

      if (response.status === 200 && response.data.success) {
        var userRoles = {
          isCustomer: true,
          isLandlord: false,
          isProfessional: false,
          isPaidProfessional: false,
          isBroker: false,
          isRealtor: false,
          // hasActiveSubscription: false,
        };
        console.log(response.data);

        if (response.data.isLandlord) {
          userRoles.isLandlord = true;
        }

        if (response.data.isProfessional) {
          userRoles.isProfessional = true;
          // Check subscription status for professional users
          // try {
          //   const subscriptionResponse = await axios.get(
          //     `${import.meta.env.VITE_BACKEND_URL}/professional/active-subscription`,
          //     { headers: { Authorization: `Bearer ${accessToken}` } }
          //   );
          //   if (subscriptionResponse.status === 200 && subscriptionResponse.data.subscription) {
          //     const subscription = subscriptionResponse.data.subscription;
          //     userRoles.hasActiveSubscription = subscription.status === "active" && subscription.plan_id !== 7; // 7 is the Basic and Free plan ID
          //   }
          // } catch (error) {
          //   console.error("Error checking subscription status:", error);
          //   userRoles.hasActiveSubscription = false;
          // }
        }

        if (response.data.isPaidProfessional) {
          userRoles.isPaidProfessional = true;
        }

        if (response.data.isBroker) {
          userRoles.isBroker = true;
        }

        if (response.data.isRealtor) {
          userRoles.isRealtor = true;
        }

        return userRoles;
      } else {
        const errorMsg = response.data.message || "Error fetching user data.";
        setErrorMessage(errorMsg);
        return null;
      }
    } catch (error) {
      console.error("Error: ", error);
      const errorMsg = "Error fetching user data. Please try again!";
      setErrorMessage(errorMsg);
      return null;
    }
  };

  const navigateToDashSection = (sectionUrl) => {
    const agenciesIndex = sectionMap.findIndex(
      (section) => section.url === sectionUrl
    );

    if (agenciesIndex !== -1) {
      setValue(agenciesIndex);
      updateCategoryParam(sectionUrl); // Update the URL parameter
    } else {
      console.error("Agencies tab not found.");
    }
  };

  const navigateToAgencies = () => {
    const agenciesIndex = sectionMap.findIndex(
      (section) => section.url === "agencies"
    );

    if (agenciesIndex !== -1) {
      setValue(agenciesIndex); // Change the tab to "Agencies"
      updateCategoryParam("agencies"); // Update the URL parameter
    } else {
      console.error("Agencies tab not found.");
    }
  };

  // Check when token is ready
  useEffect(() => {
    if (accessToken !== undefined) {
      setIsTokenReady(true);
    }
  }, [accessToken]);

  useEffect(() => {
    if (!isTokenReady) return;

    if (!accessToken) {
      navigate(`/`);
    }
  }, [isTokenReady, accessToken, navigate]);

  useEffect(() => {
    if (!isTokenReady || !accessToken) return;

    const setDashSections = async () => {
      try {
        const userRoles = await fetchUserRoles(accessToken);
        setUserRoles(userRoles);

        const baseSections = [
          { label: "Profile", url: "profile" },
          { label: "Manage profile", url: "manageprofile" },
          { label: "Messages", url: "messages" },
          { label: "Scheduling", url: "scheduling" },
          { label: "Favorite", url: "favorite" },
          { label: "Listings", url: "listings" },
        ];

        const professionalSections = [
          { label: "Pro Listings", url: "prolistings", paid: true },
          { label: "Overview", url: "overview", paid: true },
          { label: "More Information", url: "promorequeries", paid: true },
          { label: "Social Media", url: "socialmediamanager", paid: true },
          { label: "Licenses", url: "prolicenses", paid: true },
          { label: "Blogs", url: "blogs", paid: true },
          { label: "Agencies", url: "agencies", paid: true },
          { label: "Pro AI", url: "proai", disabled: true },
        ];

        // const fullSectionMap = [
        //   ...baseSections,
        //   ...professionalSections.map(section => ({
        //     ...section,
        //     disabled:
        //       !userRoles.isProfessional ||
        //       (!userRoles.isPaidProfessional && section.paid) ||
        //       section.disabled,
        //   })),
        // ];
        const fullSectionMap = [
          ...baseSections,
          ...professionalSections,
          // We do NOT overwrite `disabled` any more.
        ];

        setSectionMap(fullSectionMap);

        const validCategory = fullSectionMap.some(
          (section) => section.url === category
        );
        if (!category || !validCategory) {
          updateCategoryParam("profile");
          setValue(0);
        } else {
          const categoryIndex = fullSectionMap.findIndex(
            (section) => section.url === category
          );
          setValue(categoryIndex !== -1 ? categoryIndex : 0);
        }
      } catch (error) {
        console.error("Error setting dashboard sections:", error);
      } finally {
        setInitialLoading(false);
      }
    };

    setDashSections();
  }, [isTokenReady, accessToken, category]);

  // Handle URL params after token is validated
  useEffect(() => {
    if (!isTokenReady || !accessToken || welcomeShown) return;

    const url = new URL(window.location);

    if (isNewUser) {
      toast.success(
        "Welcome to the MyFirstLand Dashboard. Here you can view your profile, your favorites, etc.",
        { position: "top-center", autoClose: 5000 }
      );

      // Remove the `newUser` URL param after showing the message
      url.searchParams.delete("newUser");
      window.history.replaceState(null, "", url.toString());
    } else if (isNewAgency) {
      toast.success("Your agency has been successfully created!", {
        position: "top-center",
        autoClose: 5000,
      });

      // Remove the `newAgency` URL param after showing the message
      url.searchParams.delete("newAgency");
      window.history.replaceState(null, "", url.toString());
    } else if (isNewRealtor) {
      toast.success(
        "Welcome to the MyFirstLand Dashboard. Here you can manage all your listed properties, their performance, etc.",
        { position: "top-center", autoClose: 5000 }
      );

      // Remove the `newRealtor` URL param after showing the message
      url.searchParams.delete("newRealtor");
      window.history.replaceState(null, "", url.toString());
    } else if (isNewLandlord) {
      toast.success(
        "Welcome to the MyFirstLand Dashboard. Here you can manage all your listed properties, their performance, etc.",
        { position: "top-center", autoClose: 5000 }
      );

      // Remove the `newLandlord` URL param after showing the message
      url.searchParams.delete("newLandlord");
      window.history.replaceState(null, "", url.toString());
    }

    // Mark welcome messages as shown
    setWelcomeShown(true);
  }, [
    isTokenReady,
    accessToken,
    isNewUser,
    isNewAgency,
    isNewRealtor,
    isNewLandlord,
    welcomeShown,
  ]);

  useEffect(() => {
    if (!isTokenReady || !accessToken) return;

    const setDashSections = async () => {
      try {
        const updatedSectionMap = [
          { label: "Profile", url: "profile" },
          { label: "Manage profile", url: "manageprofile" },
          { label: "Messages", url: "messages" },
          { label: "Scheduling", url: "scheduling" },
          { label: "Favorite", url: "favorite" },
          { label: "Listings", url: "listings" },
        ];

        const userRoles = await fetchUserRoles(accessToken);
        setUserRoles(userRoles);

        const professionalSections = [
          { label: "Pro Listings", url: "prolistings" },
          { label: "Overview", url: "overview" },
          { label: "More Information", url: "promorequeries" },
          { label: "Social Media", url: "socialmediamanager" },
          { label: "Licenses", url: "prolicenses" },
          { label: "Blogs", url: "blogs" },
          { label: "Agencies", url: "agencies" },
          { label: "Pro AI", url: "proai", disabled: true },
        ];

        // Add professional sections and mark them as disabled if user is not a professional
        const fullSectionMap = [
          ...updatedSectionMap,
          ...professionalSections.map((section) => ({
            ...section,
            disabled: !userRoles?.isProfessional || section.disabled,
          })),
        ];

        setSectionMap(fullSectionMap);

        // Default to "profile" if no category or invalid category is present
        const validCategory = fullSectionMap.some(
          (section) => section.url === category
        );
        if (!category || !validCategory) {
          updateCategoryParam("profile");
          setValue(0); // Default to the first tab (Profile)
        } else {
          const categoryIndex = fullSectionMap.findIndex(
            (section) => section.url === category.toLowerCase()
          );
          setValue(categoryIndex !== -1 ? categoryIndex : 0);
        }
      } catch (error) {
        console.error("Error setting dashboard sections:", error);
      } finally {
        setInitialLoading(false);
      }
    };

    setDashSections();
  }, [isTokenReady, accessToken, category]); // Add `category` as a dependency

  // useEffect(() => {
  //   if (isNewRealtor) {
  //     showSuccessMessage(
  //       "Welcome to the MyFirstLand Dashboard. Here you can manage all your listed properties, their performance, etc."
  //     );
  //   }
  // }, [isNewRealtor]);

  // useEffect(() => {
  //   if (isNewLandlord) {
  //     showSuccessMessage(
  //       "Welcome to the MyFirstLand Dashboard. Here you can manage all your listed properties, their performance, etc."
  //     );
  //   }
  // }, [isNewLandlord]);

  // useEffect(() => {
  //   if (isNewUser) {
  //     showSuccessMessage(
  //       "Welcome to the MyFirstLand Dashboard. Here you can view your profile, your favorites, etc."
  //     );
  //   }
  // }, [isNewUser]);

  // useEffect(() => {
  //   if (isNewAgency) {
  //     showSuccessMessage("Your agency has been successfully created!.");

  //     // Remove "newAgency" URL param
  //     const url = new URL(window.location);
  //     url.searchParams.delete("newAgency");

  //     // Update the URL without reloading the page
  //     window.history.replaceState(null, "", url.toString());
  //   }
  // }, [isNewAgency]);

  return (
    <>
      {initialLoading ? (
        <InitialPageLoader />
      ) : (
        <>
          {pageLoading && <InitialPageLoader />}
          <Navbar />
          {!accessToken ? (
            <div>You need to be logged in to access the dashboard!</div>
          ) : (
            <div className={styles.containerWrap}>
              <div className={styles.container}>
                {errorMessage && (
                  <div className={styles.errorBox}>
                    <p>{errorMessage}</p>
                  </div>
                )}
                <Box
                  sx={{
                    flexGrow: 1,
                    bgcolor: "background.paper",
                    display: "flex",
                    minHeight: "80vh",
                  }}
                >
                  <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    sx={{
                      borderRight: 1,
                      borderColor: "divider",
                      "& .MuiTab-root": {
                        justifyContent: "flex-start", // Align text and icon to the left
                        textTransform: "none", // Keep text casing as provided
                        padding: "10px 16px", // Adjust padding for better spacing
                        fontSize: "1rem", // Increase font size for readability
                        gap: "8px", // Space between icon and text
                      },
                      "& .MuiTab-root.Mui-disabled": {
                        opacity: 0.5, // Add transparency to disabled tabs
                      },
                    }}
                  >
                    {sectionMap.map((section, index) => (
                      <Tab
                        key={section.url}
                        label={
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {(section.disabled ||
                              (section.paid && !userRoles.isPaidProfessional) ||
                              (userRoles &&
                                userRoles.isProfessional &&
                                !userRoles.isPaidProfessional &&
                                [
                                  "prolistings",
                                  "socialmediamanager",
                                  "blogs",
                                  "agencies",
                                ].includes(section.url))) && (
                              <LockIcon
                                fontSize="small"
                                style={{ marginRight: "8px" }}
                              />
                            )}
                            <span>{section.label}</span>
                          </div>
                        }
                        {...a11yProps(index)}
                        className={
                          section.disabled ||
                          (section.paid && !userRoles.isPaidProfessional)
                            ? styles.lockedTab
                            : ""
                        }
                      />
                    ))}
                  </Tabs>

                  {sectionMap.map((section, index) => (
                    <TabPanel
                      key={section.url}
                      value={value}
                      index={index}
                      className={styles.tabPanel}
                    >
                      {section.url === "profile" && <UserProfile />}
                      {/* {section.url === "overview" && <OverviewDashboard />} */}
                      {section.url === "overview" &&
                        (userRoles.isProfessional ? (
                          <OverviewDashboard />
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only.</h1>
                            <h3>
                              This feature is only accessible for professionals.
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}
                      {section.url === "favourites" && <div>Favourites</div>}
                      {section.url === "orders" && <div>Orders</div>}
                      {section.url === "listings" && (
                        <DashLandlordListings
                          showErrorMessage={showErrorMessage}
                          setPageLoading={setPageLoading}
                        />
                      )}
                      {section.url === "prolistings" &&
                        (userRoles.isProfessional ? (
                          userRoles.isPaidProfessional ? (
                            <DashProListings
                              showErrorMessage={showErrorMessage}
                              setPageLoading={setPageLoading}
                            />
                          ) : (
                            <div
                              style={{ padding: "3rem", textAlign: "center" }}
                            >
                              <LockIcon
                                style={{
                                  fontSize: "48px",
                                  color: "#666",
                                  marginBottom: "20px",
                                }}
                              />
                              <h1>This is a paid professional feature</h1>
                              <h3>Subscribe to access this feature</h3>
                              <button
                                className={styles.button}
                                onClick={() => navigate("/subscription-plans")}
                                style={{
                                  padding: "10px 15px",
                                  marginTop: "10px",
                                  border: "none",
                                  borderRadius: "5px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                  marginRight: "2px",
                                  display: "block",
                                  margin: "10px auto",
                                }}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          )
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only</h1>
                            <h3>
                              Join as a professional to access this feature
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}

                      {section.url === "favorite" && <DashFavoriteListings />}

                      {/* {section.url === "promorequeries" && (
                        <ProMoreQueries accessToken={accessToken} />
                      )} */}
                      {section.url === "promorequeries" &&
                        (userRoles.isProfessional ? (
                          <ProMoreQueries accessToken={accessToken} />
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only.</h1>
                            <h3>
                              This feature is only accessible for professionals.
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}

                      {/* {section.url === "socialmediamanager" && (
                        <SocialMediaManager />
                      )} */}
                      {section.url === "socialmediamanager" &&
                        (userRoles.isProfessional ? (
                          userRoles.isPaidProfessional ? (
                            <SocialMediaManager />
                          ) : (
                            <div
                              style={{ padding: "3rem", textAlign: "center" }}
                            >
                              <LockIcon
                                style={{
                                  fontSize: "48px",
                                  color: "#666",
                                  marginBottom: "20px",
                                }}
                              />
                              <h1>This is a paid professional feature</h1>
                              <h3>Subscribe to access this feature</h3>
                              <button
                                className={styles.button}
                                onClick={() => navigate("/subscription-plans")}
                                style={{
                                  padding: "10px 15px",
                                  marginTop: "10px",
                                  border: "none",
                                  borderRadius: "5px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                  marginRight: "2px",
                                  display: "block",
                                  margin: "10px auto",
                                }}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          )
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only</h1>
                            <h3>
                              Join as a professional to access this feature
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}
                      {/* {section.url === "prolicenses" && (
                        <DashProLicenses
                          accessToken={accessToken}
                          isAgencyOnboard={isAgencyOnboard}
                          navigateToAgencies={() =>
                            navigateToDashSection("agencies")
                          }
                        />
                      )} */}
                      {section.url === "prolicenses" &&
                        (userRoles.isProfessional ? (
                          <DashProLicenses
                            accessToken={accessToken}
                            isAgencyOnboard={isAgencyOnboard}
                            navigateToAgencies={() =>
                              navigateToDashSection("agencies")
                            }
                          />
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only.</h1>
                            <h3>
                              This feature is only accessible for professionals.
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}
                      {/* {section.url === "blogs" && (
                        <DashProBlogs accessToken={accessToken} />
                      )} */}
                      {section.url === "blogs" &&
                        (userRoles.isProfessional ? (
                          userRoles.isPaidProfessional ? (
                            <DashProBlogs accessToken={accessToken} />
                          ) : (
                            <div
                              style={{ padding: "3rem", textAlign: "center" }}
                            >
                              <LockIcon
                                style={{
                                  fontSize: "48px",
                                  color: "#666",
                                  marginBottom: "20px",
                                }}
                              />
                              <h1>This is a paid professional feature</h1>
                              <h3>Subscribe to access this feature</h3>
                              <button
                                className={styles.button}
                                onClick={() => navigate("/subscription-plans")}
                                style={{
                                  padding: "10px 15px",
                                  marginTop: "10px",
                                  border: "none",
                                  borderRadius: "5px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                  marginRight: "2px",
                                  display: "block",
                                  margin: "10px auto",
                                }}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          )
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only</h1>
                            <h3>
                              Join as a professional to access this feature
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}
                      {/* {section.url === "agencies" && (
                        <DashProAgencies
                          accessToken={accessToken}
                          userRoles={userRoles}
                          navigateToLicenses={() =>
                            navigateToDashSection("prolicenses")
                          }
                        />
                      )} */}
                      {section.url === "agencies" &&
                        (userRoles.isProfessional ? (
                          userRoles.isPaidProfessional ? (
                            <DashProAgencies
                              accessToken={accessToken}
                              userRoles={userRoles}
                              navigateToLicenses={() =>
                                navigateToDashSection("prolicenses")
                              }
                            />
                          ) : (
                            <div
                              style={{ padding: "3rem", textAlign: "center" }}
                            >
                              <LockIcon
                                style={{
                                  fontSize: "48px",
                                  color: "#666",
                                  marginBottom: "20px",
                                }}
                              />
                              <h1>This is a paid professional feature</h1>
                              <h3>Subscribe to access this feature</h3>
                              <button
                                className={styles.button}
                                onClick={() => navigate("/subscription-plans")}
                                style={{
                                  padding: "10px 15px",
                                  marginTop: "10px",
                                  border: "none",
                                  borderRadius: "5px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s",
                                  marginRight: "2px",
                                  display: "block",
                                  margin: "10px auto",
                                }}
                              >
                                Subscribe Now
                              </button>
                            </div>
                          )
                        ) : (
                          <div style={{ padding: "3rem", textAlign: "center" }}>
                            <LockIcon
                              style={{
                                fontSize: "48px",
                                color: "#666",
                                marginBottom: "20px",
                              }}
                            />
                            <h1>This feature is for professionals only</h1>
                            <h3>
                              Join as a professional to access this feature
                            </h3>
                            <button
                              className={styles.button}
                              onClick={() => navigate("/realtor-landing")}
                              style={{
                                padding: "10px 15px",
                                marginTop: "10px",
                                border: "none",
                                borderRadius: "5px",
                                backgroundColor: "#007bff",
                                color: "white",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                marginRight: "2px",
                                display: "block",
                                margin: "10px auto",
                              }}
                            >
                              Join as a Pro
                            </button>
                          </div>
                        ))}
                      {section.url === "manageprofile" && (
                        <ManageProfile
                          accessToken={`Bearer ${accessToken}`}
                          userRoles={userRoles}
                        />
                      )}
                      {section.url === "proai" && <ProAiChatBot />}
                      {section.url === "messages" && (
                        <DashChat
                          targetUser={
                            "targetUser" in locationProps &&
                            locationProps.targetUser
                              ? locationProps.targetUser
                              : {}
                          }
                          targetMessage={
                            "targetMessage" in locationProps &&
                            locationProps.targetMessage
                              ? locationProps.targetMessage
                              : ""
                          }
                          accessToken={accessToken}
                          userDetails={userDetails}
                          chatIdFromParams={chatIdFromParams}
                          targetUserIdFromParams={targetUserIdFromParams}
                        />
                      )}

                      {section.url === "scheduling" && (
                        <Scheduling userDetails={userDetails} />
                      )}
                    </TabPanel>
                  ))}
                </Box>
              </div>
            </div>
          )}
          <Footer />
        </>
      )}
    </>
  );
}

export default DashHome;
